import React from 'react';
import { Toaster } from 'react-hot-toast';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import LoginPage from './auth/LoginPage';
import HomePage from './pages/HomePage';
import About from './pages/About';
import Item from './pages/Item';
import Products from './pages/Products';
import ProductList from './pages/ProductList';
import Cart from './pages/Cart';
import Wishlist from './pages/Wishlist';
import { ProductProvider } from './context/ProductContext';
import './styles/index.css';

const router = createBrowserRouter([
  {
    path: '/',
    element: <HomePage />,
    children: [
      { path: 'about', element: <About /> },
      { path: 'product/:id', element: <Item /> },
      { path: 'category/:categoryName', element: <ProductList /> },
      { path: 'products', element: <Products /> },
      { path: 'cart', element: <Cart /> },
      { path: 'wishlist', element: <Wishlist /> },
    ],
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
]);

const App = () => {
  return (
    <ProductProvider>
      <Toaster />
      <RouterProvider router={router} />
    </ProductProvider>
  );
};

export default App;
